import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import CSS from 'csstype';
import { PADDING_SIZE, SPACING_SIZE } from './constants';

export type SpacerProps = {
  alignItems?: CSS.Property.AlignItems;
  backgroundColor?: CSS.Property.BackgroundColor;
  children: React.ReactNode;
  flexBasis?: CSS.Property.FlexBasis;
  flexDirection?: CSS.Property.FlexDirection;
  flexGrow?: CSS.Property.FlexGrow;
  flexShrink?: CSS.Property.FlexShrink;
  flexWrap?: CSS.Property.FlexWrap;
  gap?: keyof typeof SPACING_SIZE | (string & NonNullable<unknown>);
  height?: string | number;
  justifyContent?: CSS.Property.JustifyContent;
  padding?: keyof typeof PADDING_SIZE | (string & NonNullable<unknown>);
  width?: string | number;
  alignSelf?: CSS.Property.AlignSelf;
};

const SpacerWrapper = styled.div`
  display: flex;
`;

export const FlexSpacer = ({
  alignItems = 'center',
  backgroundColor,
  children,
  flexBasis,
  flexDirection,
  flexGrow,
  flexShrink,
  flexWrap,
  gap = 'half',
  height,
  justifyContent = 'flex-start',
  padding = 'noPadding',
  width,
  alignSelf,
  ...props
}: SpacerProps) => {
  /**
   * The styles that will be applied to the Flex Spacer Component
   */
  const style = {
    alignItems,
    flexBasis,
    flexDirection,
    flexGrow,
    flexShrink,
    flexWrap,
    alignSelf,
    gap: gap in SPACING_SIZE ? SPACING_SIZE[gap as keyof typeof SPACING_SIZE] : gap,
    justifyContent,
    padding: padding in PADDING_SIZE ? PADDING_SIZE[padding as keyof typeof PADDING_SIZE] : padding,
    backgroundColor,
    ...(height && { height: typeof height === 'number' ? `${pxToRem(height)}` : height }),
    ...(width && { width: typeof width === 'number' ? `${pxToRem(width)}` : width }),
  };

  return (
    <SpacerWrapper style={style} {...props}>
      {children}
    </SpacerWrapper>
  );
};
